import React, { useEffect, useRef } from "react";

const InventoryPopup = ({isOpen, setOpen, component}) => {

    if(!isOpen) return null;
    const popupRef = useRef(null);

    const handleClickOutside = (event) => {
        if (popupRef.current && !popupRef.current.contains(event.target)) {
            setOpen(false);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
        document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
    
    return (
        <div className="popup">
            <div className="popup__inner inventory" ref={popupRef}>
                <a className="popup__inner--close" onClick={() => setOpen(false)}>
                    <svg>
                        <use href="/ui/images/sprites/brenderup.svg#close"></use>
                    </svg>
                </a>
                {component}
            </div>
        </div>
    );
}

export default InventoryPopup;